import { mapActions, mapState, mapGetters } from 'vuex'
import { GET_OPEN_PAYMENTS } from '@/utils/store/actionTypes'
import { OPEN_PAYMENTS } from '@/utils/store/getterTypes'

export default {
  async fetch () {
    if (this.openPayments.length === 0 && this.loggedIn) {
      try {
        await this.getOpenPayments()
      } catch (e) {
        this.$ota.general.logError(e)
      }
    }
  },
  computed: {
    ...mapState('auth', {
      loggedIn: state => state.loggedIn
    })
  },
  methods: {
    ...mapActions('payment', {
      getOpenPayments: GET_OPEN_PAYMENTS
    }),
    ...mapGetters('payment', {
      openPayments: OPEN_PAYMENTS
    })
  }
}
